import React, { Fragment, useCallback, useId, useState } from 'react'
import axios from 'lib/axios'
import ToggleCheckbox from '../../components/checkbox'

const EnableCheckbox = ({ organizationId, enabled, updateEnabled, updating, setUpdating }) => {
  const changeValue = async (enabled) => {
    try {
      setUpdating(true)
      const url = `/super/organizations/${organizationId}/questionnaires/enable_auto_archive`
      await axios.post(url, { is_auto_archive_on: enabled ? 1 : 0 })
      updateEnabled(enabled)
    } catch (error) {
      console.log(error)
    } finally {
      setUpdating(false)
    }
  }

  return (
    <div className="dome-d-flex dome-align-start">
      <ToggleCheckbox
        label="enable auto-archive"
        defaultChecked={enabled}
        disabled={updating}
        onChange={(e) => changeValue(e.target.checked)}
      />
    </div>
  )
}

export default function EnableAutoArchive({ organizationId, enabled, updateEnabled }) {
  const [updating, setUpdating] = useState(false)

  return (
    <div className="questionnaire-admin-general-row">
      <EnableCheckbox
        organizationId={organizationId}
        enabled={enabled}
        updateEnabled={updateEnabled}
        updating={updating}
        setUpdating={setUpdating}
      />
    </div>
  )
}
